import React from "react";
import "./PricingCard.css";

import {
    FiShield,
    FiRefreshCw,
    FiCheckCircle,
} from "react-icons/fi";

const PricingCard = () => {

    const stats = [
        {
            value: "Dedicated",
            label: "Placement Assistance",
            className: "stat-purple",
        },
        {
            value: "2 Months",
            label: "Real-World Capstone Projects",
            className: "stat-pink",
        },
        {
            value: "15 Max",
            label: "Students Per Classroom",
            className: "stat-purple",
        },
        {
            value: "50% Refund",
            label: "Placement Guarantee",
            className: "stat-orange",
        },
    ];

    const benefits = [
        "Live Hands-On Capstone Projects",
        "Industry Recognized Skill Certificate",
        "Dedicated 1:1 Success Coach",
    ];

    return (
        <section className="pricing-card-section">

            {/* =================================================
                TOP STATISTICS
            ================================================= */}

            <div className="pricing-stats">

                {stats.map((stat, index) => (
                    <div
                        className={`pricing-stat ${stat.className}`}
                        key={index}
                    >
                        <h3>
                            {stat.value}
                        </h3>

                        <p>
                            {stat.label}
                        </p>
                    </div>
                ))}

            </div>


            {/* =================================================
                REFUND GUARANTEE CARD
            ================================================= */}

            <div className="pricing-refund-card">

                {/* ================= LEFT CONTENT ================= */}

                <div className="pricing-refund-content">

                    {/* BADGE */}

                    <div className="pricing-refund-badge">

                        <FiShield />

                        <span>
                            100% TRANSPARENCY &amp; PEACE OF MIND
                        </span>

                    </div>


                    {/* HEADING */}

                    <h2 className="pricing-refund-title">

                        <span className="title-white">
                            Risk-Free Learning with
                        </span>

                        <span className="title-gradient">
                            50% Refund Guarantee Protection
                        </span>

                    </h2>


                    {/* DESCRIPTION */}

                    <p className="pricing-refund-description">
                        At PRT Academy, we stand behind our curriculum
                        quality and mentorship. If you complete our course
                        requirements, assignments, and mock interview rounds
                        and are not placed, you are eligible for a{" "}
                        <strong>
                            50% course fee refund
                        </strong>{" "}
                        under standard terms.
                    </p>


                    {/* BENEFITS */}

                    <div className="pricing-refund-benefits">

                        {benefits.map((benefit, index) => (
                            <div
                                className="pricing-refund-benefit"
                                key={index}
                            >

                                <FiCheckCircle />

                                <span>
                                    {benefit}
                                </span>

                            </div>
                        ))}

                    </div>

                </div>


                {/* ================= RIGHT REFUND BOX ================= */}

                <div className="pricing-refund-box">

                    <div className="pricing-refund-icon">
                        <FiRefreshCw />
                    </div>

                    <h3>
                        50% REFUND
                    </h3>

                    <p>
                        If Not Placed (T&amp;C Apply)
                    </p>

                    <div className="pricing-refund-divider"></div>

                    <span>
                        100% Transparent · Protection Policy Guarantee
                    </span>

                </div>

            </div>

        </section>
    );
};

export default PricingCard;